import React, { FC } from "react";
import { Box, Select } from "common/components/ui";
import { FormattedMessage } from "common/components/ui/FormattedMessage";
import { useReplenishmentWarehouseSelect } from "./useReplenishmentWarehouseSelect";
import { ReplenishmentWarehouseSelectLabels } from "./ReplenishmentWarehouseSelectLabels";
import { InventoryPool } from "@deliverr/business-types";

export const ReplenishmentWarehouseSelect: FC<{
  shouldAddProductInventory?: boolean;
  inventoryPool?: InventoryPool;
}> = ({
  shouldAddProductInventory = true, // TODO - Remove when combining parent inventory is no longer required
  inventoryPool = InventoryPool.STORAGE,
}) => {
  const {
    isWarehouseSelectionLoading,
    selectedWarehouseOption,
    warehouseOptions,
    customComponents,
    onWarehouseChange,
    formatOptionLabel,
  } = useReplenishmentWarehouseSelect(shouldAddProductInventory, inventoryPool);

  return (
    <Box paddingTop={"S4"} width={"300px"}>
      <Select
        placeholder={<FormattedMessage {...ReplenishmentWarehouseSelectLabels.selectWarehouse} />}
        options={warehouseOptions}
        value={selectedWarehouseOption}
        formatOptionLabel={formatOptionLabel}
        components={customComponents}
        onChange={onWarehouseChange}
        isLoading={isWarehouseSelectionLoading}
      />
    </Box>
  );
};
